<ion-header>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div translate>PROFILE.MYACCOUNT</div>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding" no-bounce>

  <ion-list>
    <ion-item button (click)="showPasswordSetPage()" style="width: 100%"><div translate>PROFILE.CHANGE_PASSWORD</div></ion-item>
    <ion-item button (click)="logout()"><div translate>PROFILE.LOGOUT</div></ion-item>
    <ion-item button (click)="unregister()"><div translate>PROFILE.UNREGISTER</div></ion-item>
  </ion-list>

</ion-content>
